import React from 'react';

// Renders heading copy with the orange italic accent: words wrapped in
// *asterisks* and any "&" become <em>. Plain text otherwise (no HTML), so
// admin-edited copy can't inject markup.
const AccentText = ({ text }) =>
  String(text || '')
    .split(/(\*[^*]+\*|&)/)
    .map((part, i) => {
      if (part === '&') return <em key={i}>&amp;</em>;
      if (part.length > 2 && part.startsWith('*') && part.endsWith('*')) {
        return <em key={i}>{part.slice(1, -1)}</em>;
      }
      return <React.Fragment key={i}>{part}</React.Fragment>;
    });

export default AccentText;
